'use strict';

require('../../styles/beauty/checkout.scss');

var _AttentiveCheckout = require('../components/AttentiveCheckout');

var selectors = {
  addressPicker: '[data-address-selector]'
};

var addressPicker = document.querySelector(selectors.addressPicker) || null;

var init = function init() {
  if (window.Shopify.Checkout.step == 'thank_you') {
    // Fire Attentive POST to subscribe customer
    (0, _AttentiveCheckout.AttentiveOptin)();
  } else {
    // Add checkbox to opt in to Attentive and set cookie when selected
    (0, _AttentiveCheckout.HandleAttentiveCookie)();
  }
};

// Switching the address picker to "Use New Address" resets the address markup,
// so we have to re-inject Attentive checkbox. The conditionals limit DOM changes
// to absolute minimum requried.
if (addressPicker) {
  addressPicker.addEventListener('change', function () {
    setTimeout(init, 250);
  }, false);
}

document.addEventListener('page:load', init, false);